import { ExpandableText, PageSection, PageWrapper } from '@src/components';
import {
  DocumentText,
  Mobile,
  TaskSquare,
  TickCircle,
  WifiSquare,
} from 'iconsax-react';
import { PackageCard, PackageDetailsItem, SimilarPlans } from './components';
import { Package } from '@src/services/packages/packageApiSliceTypes';
import { getCurrencySymbol } from '@src/utilities/currency';
import { useState } from 'react';
import { Checkout } from '../Checkout';
import { useTranslation } from 'react-i18next';
import { ResponsiveModal } from '@src/components/ResponsiveModal';
import { useQueryParams } from '@src/hooks';
import { Button } from 'antd';

interface PackageDetailsProps {
  item: Package;
  flagSrc?: string;
  isOpen: boolean;
  onClose: () => void;
}
export function PackageDetails({
  item: initialItem,
  flagSrc,
  isOpen,
  onClose,
}: Readonly<PackageDetailsProps>) {
  const { t } = useTranslation();
  const { getQueryParam } = useQueryParams();
  const [openPay, setOpenPay] = useState(false);
  const [item, setItem] = useState(initialItem);

  const countryId = getQueryParam('countryId');

  const handleCloseCheckout = () => {
    setTimeout(() => {
      setOpenPay(false);
    }, 300);
  };
  return (
    <>
      <ResponsiveModal
        title='Package details'
        headerIcon={false}
        isOpen={isOpen}
        onClose={onClose}
        className='md:!w-[700px]'
        content={
          <PageWrapper rootClassName='space-y-2'>
            <PageSection className='bg-wl-background p-4 !rounded-xl'>
              <PackageCard
                item={item}
                country={{ flag: flagSrc }}
                showPrice={false}
                className={`mb-6 bg-transparent ${item.isBestSeller || item.isPopular || item.discountPercentage ? '!py-4' : '!py-0'} !px-0`}
              />
              <div className='grid md:grid-cols-2 w-full gap-4'>
                <PackageDetailsItem
                  icon={<WifiSquare />}
                  title='Network Operators'
                  value={item?.network}
                />
                <PackageDetailsItem
                  icon={<Mobile />}
                  title='Plan Types'
                  value='Data only'
                />
                <PackageDetailsItem
                  icon={<TaskSquare />}
                  title='eKYC'
                  value='Not Required'
                />
                <PackageDetailsItem
                  icon={<DocumentText />}
                  title='Validity Policy'
                  value='Activates upon first data usage'
                />
                <PackageDetailsItem icon={<TickCircle />} value='Hotspot' />
                <PackageDetailsItem
                  icon={<TickCircle />}
                  value='Top-Up option'
                />
              </div>
            </PageSection>
            <div className='grid gap-2 md:gap-4 md:grid-cols-2'>
              <div className='p-4 rounded-xl bg-wl-alert-container-light dark:bg-yellow-900/20 text-wl-on-background'>
                {t('pages.packageDetails.alert.activation')}
              </div>
              <div className='p-4 rounded-xl bg-wl-alert-container-light dark:bg-yellow-900/20 text-wl-on-background'>
                {t('pages.packageDetails.alert.support')}
              </div>
            </div>
            {item?.description && (
              <PageSection className='my-4 p-4 text-wl-on-background'>
                <div className='font-bold mb-4'>
                  {t('pages.packageDetails.title')}
                </div>
                <ExpandableText text={item?.description} lineClamp={2} />
              </PageSection>
            )}
            <SimilarPlans packageId={item.id} onSelectItem={setItem} />
          </PageWrapper>
        }
        footer={
          <PageSection className='z-10 flex items-center w-full bg-wl-background'>
            <span className='w-[30%] text-md truncate text-center text-wl-on-background'>
              {item.discountPercentage > 0 ? (
                <>
                  <div className='text-sm text-wl-secondary line-through'>
                    {getCurrencySymbol(item.currency)}
                    {item.price}
                  </div>
                  <div className='text-lg font-semibold'>
                    {getCurrencySymbol(item.currency)}
                    {item.discountedPrice}
                  </div>
                </>
              ) : (
                <div className='text-lg font-semibold'>
                  {getCurrencySymbol(item.currency)}
                  {item.price}
                </div>
              )}
            </span>
            <Button
              className='btn-primary w-[70%]'
              onClick={() => setOpenPay(true)}
            >
              Buy now
            </Button>
          </PageSection>
        }
      />
      {openPay && (
        <Checkout
          isOpen={openPay}
          country={{ id: countryId!, flag: flagSrc! }}
          selectedPackage={item}
          onClose={handleCloseCheckout}
        />
      )}
    </>
  );
}
